import React, { useContext, useEffect } from "react";
import { Table } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import {
  getDateFormatDDMMAAAA,
  getStateBetweenDates,
} from "../../../../app/util/dateOptions";
import { getDocumentType } from "../../../../app/util/listOfValoursOptions";
import LoadingComponent from "../../../../app/layout/LoadingComponent";

const ListResolutions = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { getResolutions, resolutions, loadData } = rootStore.resolutionStore;

  useEffect(() => {
    getResolutions();
  }, [getResolutions]);
  if (!loadData) return <LoadingComponent content="Cargando" />;
  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Tipo de factura</Table.HeaderCell>
          <Table.HeaderCell>No. Autorización</Table.HeaderCell>
          <Table.HeaderCell>Fecha Resolución</Table.HeaderCell>
          <Table.HeaderCell>Fecha inicial</Table.HeaderCell>
          <Table.HeaderCell>Fecha final</Table.HeaderCell>
          <Table.HeaderCell>Prefijo </Table.HeaderCell>
          <Table.HeaderCell>Rango desde </Table.HeaderCell>
          <Table.HeaderCell>Rango hasta</Table.HeaderCell>
          <Table.HeaderCell>Clave Tecnica</Table.HeaderCell>
          <Table.HeaderCell>Estado </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {resolutions?.length > 0 ? (
          resolutions.map((resolution) => (
            <Table.Row key={resolution.id}>
              <Table.Cell>{getDocumentType(resolution.entryType)}</Table.Cell>
              <Table.Cell className="centertd" >{resolution.invoiceAuthorization}</Table.Cell>
              <Table.Cell className="centertd" >
                {getDateFormatDDMMAAAA(resolution.authorizationDate)}
              </Table.Cell>
              <Table.Cell className="centertd" >
                {getDateFormatDDMMAAAA(resolution.startDate)}
              </Table.Cell>
              <Table.Cell className="centertd" >
                {getDateFormatDDMMAAAA(resolution.endDate)}
              </Table.Cell>
              <Table.Cell className="centertd" >{resolution.prefix}</Table.Cell>
              <Table.Cell className="centertd" >{resolution.from}</Table.Cell>
              <Table.Cell className="centertd" >{resolution.to}</Table.Cell>
              <Table.Cell className="centertd" >{!resolution.technicalKey ? "No" : "Si"}</Table.Cell>
              <Table.Cell className="centertd" >
                {getStateBetweenDates(resolution.startDate, resolution.endDate)}
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="resolutionNull">
            <Table.Cell>No existen resoluciones </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    </div>
  );
};

export default observer(ListResolutions);
